import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { formatDate } from '../../../utils/dates';
import { IClassesBookClassItem } from '../types';
import BadgeStatus from '../parts/BadgeStatus';

export const useClassesBookClassColumns = () => {
  const { t } = useTranslation(TranslationsKeys.CLASSES_BOOK_EDIT);

  const columns = useMemo<ColumnTable<IClassesBookClassItem>[]>(
    () => [
      {
        headerText: t(`classes.table.name`),
        tdClassName: 'text-center fw-700',
        thClassName: 'text-center',
        columnName: 'name',
        width: 190,
        cellFormat({ value }) {
          return value;
        },
      },
      {
        headerText: t(`classes.table.date`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'date',
        width: 190,
        cellFormat({ value }) {
          return value ? formatDate(value, 'DD/MM/YYYY') : 'N/D';
        },
      },
      {
        headerText: t(`classes.table.lessonStatus`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'lessonStatus',
        width: 190,
        cellFormat({ value }) {
          return t(`classes.lessonStatuses.${value}`);
        },
      },
      {
        headerText: t(`classes.table.activities`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'description',
        cellFormat({ row }) {
          return (
            <div>
              <BadgeStatus status={row?.status} />
            </div>
          );
        },
      },
    ],
    [t],
  );
  return columns;
};
